module.exports = __webpack_public_path__ + "img/filter-funnel.aff17fc4.svg";